<template>
  <form class="mt-3" v-on:submit.prevent>
    <div class="card p-3 mb-3">
      <h4>Decoration</h4>

      <div class="row">
        <div class="col-md-4">
          <validated-input v-model="item.name" label="Name" :name="`Name`" validate="required|max:40" />
        </div>
        <div class="col-md-4">
          <validated-input
            v-model="item.decorationId"
            label="Decoration Id"
            :name="`decorationId`"
            validate="numeric|max:40"
          />
        </div>

        <div class="col-md-4">
          <validated-input v-model="item.leadTime" label="Lead Time" validate="numeric" :optional="true" mask="##" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <validated-input
            v-model="item.rushLeadTime"
            label="Rush Lead Time"
            validate="numeric"
            :optional="true"
            mask="##"
          />
        </div>
        <div class="col-md-4">
          <b-form-group>
            <div class="d-flex justify-content-between align-items-center">
              <label>Geometry</label>
              <small>optional</small>
            </div>
            <b-form-select
              v-model="item.geometry"
              :options="['rectangle', 'rectangular', 'square', 'circle', 'circular', 'other']"
              name="geometry"
            />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <b-form-group>
            <div class="d-flex justify-content-between align-items-center">
              <label>Uom</label>
              <small>optional</small>
            </div>
            <b-form-select v-model="item.uom" :options="['inches', 'other', 'stitches', 'colors']" name="geometry" />
          </b-form-group>
        </div>
        <div class="col-md-4">
          <validated-input
            v-model="item.diameter"
            v-if="['circle', 'circular'].includes(item.geometry)"
            label="Diameter"
            validate="decimal"
          />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4" v-if="['rectangle', 'rectangular', 'square'].includes(item.geometry)">
          <validated-input v-model="item.width" label="Width" validate="decimal:2|max_value:1000" />
        </div>
        <div class="col-md-4" v-if="['rectangle', 'rectangular'].includes(item.geometry)">
          <validated-input v-model="item.height" label="Height" validate="decimal:2|max_value:1000" />
        </div>
      </div>

      <div class="row">
        <div class="col-md-4">
          <validated-input
            v-model="item.decoration_units_max"
            label="Decoration Units Max"
            :name="`decorationUnitsMax`"
            validate="required"
            :help-options="{
              content: 'This is the max number of decoration units for this decoration/location combination.',
              html: true
            }"
          />
        </div>
        <div class="col-md-4">
          <validated-input
            v-model="item.decoration_units_included"
            label="Decoration Units Included"
            :name="`decorationUnitsIncluded`"
            validate="numeric|max:7500"
            :help-options="{
              content:
                'The number of included decoration units. For example, if 1 color decoration is included set value to “1”. If 7,500 stiches are included set value to “7500”',
              html: true
            }"
          />
        </div>
        <div class="col-md-4">
          <validated-input
            label="Decoration Units Included Uom"
            v-model="item.decoration_units_included_uom"
            :options="optionsUnits"
            :type="'select'"
            :help-options="{
              content: 'Values are enumerated: {Colors, Inches, Other, Stitches, SquareInches }.',
              html: true
            }"
          />
        </div>
      </div>
    </div>
    <div v-if="!itemParent && !item._id" class="card p-3 mb-4">
      <autocomplete-input
        :path="`/products/${product._id}/locations/all`"
        name="Decoration Locations"
        placeholder="Select locations"
        :required="true"
        :multiple="true"
        isObject
        track-by="_id"
        label="name"
        loadOnFocus
        v-model="item.locations"
        :options-v="[]"
      />
    </div>
    <array-card
      v-model="item.colors"
      :default-item="{ name: '', hex: '', colorId: '', colorValue: '', system: '' }"
      :paginate="item.colors && item.colors.length > 10"
      :per-page="10"
      :minDeleteSize="0"
      heading="Colors"
      class="card mb-3 p-3"
      heading-class="h4">
      <template v-slot:default="propsColors">
        <div class="row">
          <div class="col-md-6">
            <validated-input v-model="propsColors.item.name" label="Name" validate="required" class="mr-2" />
          </div>
          <div class="col-md-6">
            <validated-input v-model="propsColors.item.hex"  :validate="{ regex: /^#(?:[0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/ }" description="Example: #000000" label="Hex" class="mr-2" />
          </div>
          <div class="col-md-6">
            <validated-input v-model="propsColors.item.system" type="select" :options="colorsSystems" label="System" class="mr-2" />
          </div>
          <div class="col-md-6">
            <validated-input
              v-model="propsColors.item.colorValue"
              label="Color Value"
              validate="required"
              class="mr-2"
            />
          </div>
          <div class="col-md-6">
            <validated-input
              v-model="propsColors.item.colorId"
              :readonly="true"
              label="Color Id"
              class="mr-2"
            />
          </div>
        </div>
      </template>
    </array-card>
    <div class="card p-3 mb-4">
      <div class="">
        <h4>Image</h4>
      </div>
      <div class="card p-3 bg-light">
        <UploadButton
          accept="*"
          v-model="medias"
          :hasUploadFromLink="true"
          :folder="uploadFolder"
          :hasImageType="false"
          resize="300"
          :compress="compress"
          :isResizeToSquare="true"
          :visibleAttached="!item._id"
          :uploadOnly="!!item._id"
          @add="saveMedia($event)"
          @remove="deleteMedia"
          class="my-2">
          <template slot="settings" slot-scope="props">
            <div class="d-flex align-items-center mb-2">
              <div class="custom-control custom-checkbox">
                <input v-model="compress" class="custom-control-input" :id="`styled-checkbox`" type="checkbox" />
                <label class="custom-control-label" :for="`styled-checkbox`">Compress</label>
              </div>
            </div>
          </template>
        </UploadButton>
      </div>
    </div>
    <div class="row" v-if="error">
      <span class="col-md-12 text-danger">{{ error.message }}</span>
    </div>
    <div class="mt-3 d-flex align-center justify-content-end">
      <b-btn @click="cancel" variant="primary" class="btn btn-light mr-2"> Close </b-btn>
      <b-btn @click="submit" variant="primary" :disabled="errors.any() || pending">
        <i class="far fa-spinner-third fa-spin text-white" v-show="pending"></i>
        Save
      </b-btn>
    </div>
  </form>
</template>
<script>
import { DISCOUNT_CODES } from '../../../../../../../libs/discountCodes';
import { createDecorationMedia, deleteMedia } from '@/api/medias';
export default {
  components: {
    UploadButton: () => import('@/components/UploadButton')
  },
  props: {
    options: Object,
    error: Object | Boolean,
    item: Object,
    itemParent: Object,
    product: Object,
    pending: Boolean
  },
  data() {
    return {
      DISCOUNT_CODES,
      colorsSystems: ['CMYK', 'Other', 'PMS', 'RGB', 'Thread'],
      compress: false,
      optionsUnits: ['Colors', 'Inches', 'Other', 'Stitches', 'SquareInches'].map((e) => e.toLowerCase())
    };
  },
  computed: {
    medias() {
      return this.item._id && this.item.image ? [this.item.image] : [];
    },
    uploadFolder() {
      return `${this.product.supplierCode || 'suppliers'}/${this.product.productId || 'products'}/${
        this.itemParent?._id || 'decorations'
      }/${this.item._id || 'locations'}`;
    }
  },
  mounted() {
    if (!this.item.colors) {
      this.$set(this.item, 'colors', []);
    }
  },
  methods: {
    async submit(e) {
      e.preventDefault();
      await this.$validator.validateAll();
      if (this.errors.any()) return console.log(this.errors.any());
      this.$emit('submit', this.item);
    },
    cancel() {
      this.$emit('cancel');
    },
    async saveMedia(media) {
      if (!this.item._id) {
        return;
      }
      const parentId = this.itemParent?._id ? this.itemParent._id : this.item.locationId;
      const image = await createDecorationMedia(media, this.product._id, parentId, this.item._id);
      this.$set(this.item, 'image', image);
    },
    deleteMedia(media) {
      deleteMedia(media._id);
      this.item.image = null;
    }
  }
};
</script>
